<template>
  <div>
    <tables :config="config()" />
  </div>
</template>

<script>
  import { get, post, put, destroy } from "@/service/Axios";
  export default {
    data () {
      return {
        list: []
      }
    },
    components: {
      tables: () => import(/* webpackPrefetch: true */ '@/components/basic/table.vue')
    },
    computed: {
      
    },
    watch: {
      
    },
    mounted () {
      this.fetch()
    },
    methods: {
      fetch () {
        this.fetchIndicator()
      },
      async fetchIndicator () {
        let params = {
          limit: 100000,
          par_id: 2,
          // 'id[neq]': 8
        }

        this.list = []

        await get('admin/indicator/data_cmb', { params })
        .then(response => {
          let res = response.data
            
          if (res.status === 200) {
            // this.list = this.changeData(res.results.data)

            res.results.data.map(obj => {
              this.list.push({
                text: obj.name,
                value: obj.id
              })
            })

            this.list.push({
              text: 'Kegiatan Lainnya',
              value: 14
            })
          }
        })
      },
      changeData (data_array) {
        function filter (array, condition) {
          let result = []

          for (let i = 0; i < array.length; i++) {
            if (condition(array[i])) {
              result.push(array[i])
            }
          }

          return result
        }

        function getChilds (parentKey, items) {
          let subItems = filter(items, function (n) {
            return n.par_id === parentKey
          })

          let result = []

          for (let i = 0; i < subItems.length; i++) {
            let subItem = subItems[i]

            let kids = getChilds(subItem.id, items)
            if (kids.length) {
              subItem.children = kids
            }

            result.push(subItem)
          }

          if (parentKey.length) {
            return result
          } else {
            return result[0]
          }
        }

        const data = data_array

        let richMediaData = getChilds('0', data)

        return richMediaData
      },
      config () {
        return {
          // CONFIG PARSING API
          api: 'admin/event/data',

          // SINGLE
          single: true,

          // CHECKBOX
          checkbox: false,

          // PADDING
          padding: 'py-0',

          // HEIGHT
          height: true,

          // CONFIG PARSING HEADER
          header: [
            {
              text: '#No',
              width: '75px',
              value: 'index',
              sortable: false,
              freeze: true,
              hide: false,
              align: 'center'
            },
            {
              text: 'indikator',
              width: '400px',
              value: 'indicator_name',
              freeze: false,
              hide: false
            },
            {
              text: 'Judul',
              width: '400px',
              value: 'title',
              freeze: false,
              hide: false
            },
            {
              text: 'Deskripsi',
              width: '400px',
              value: 'desc',
              freeze: false,
              hide: false
            },
            {
              text: 'Lokasi',
              width: '400px',
              value: 'location',
              freeze: false,
              hide: false
            },
            {
              text: 'Tanggal Mulai',
              width: '200px',
              value: 'start_date',
              freeze: false,
              hide: false,
              format: 'date'
            },
            {
              text: 'Tanggal Selesai',
              width: '200px',
              value: 'end_date',
              freeze: false,
              hide: false,
              format: 'datetime'
            },
            {
              text: 'Jam Mulai',
              width: '200px',
              value: 'start_time',
              freeze: false,
              hide: false
            },
            {
              text: 'Jam Selesai',
              width: '200px',
              value: 'end_time',
              freeze: false,
              hide: false
            }
          ],

          // CONFIG PARSING FILTER
          filter: [],

          // PREFIX KEY
          prefix: '',

          // CONFIG PARSING FORM
          form: [
            {
              field: 'id',
              label: 'ID',
              type: 'id',
              placeholder: 'Contoh. 1',
              value: '',
              width: '20%',
              required: false,
              hide: true
            },
            {
              field: 'image_url',
              label: 'Gambar',
              type: 'image',
              placeholder: 'Contoh. Upload Gambar',
              value: '',
              width: '100%',
              required: false
            },
            {
              field: 'title',
              label: 'Judul',
              type: 'text',
              placeholder: 'Contoh. Agenda Tahunan',
              value: '',
              width: '70%',
              required: true,
              rules: 'required'
            },
            {
              field: 'desc',
              label: 'Deskripsi',
              type: 'textarea',
              placeholder: 'Contoh. Agenda tahun 2023',
              value: '',
              width: '100%',
              rows: 3,
              required: true,
              rules: 'required'
            },
            {
              field: 'indicator_id',
              label: 'Indikator',
              type: 'select',
              placeholder: 'Contoh. Penilaian Atasan Langsung',
              value: '',
              option: this.list,
              width: '100%',
              required: true,
              rules: 'required'
            },
            {
              field: 'location',
              label: 'Lokasi',
              type: 'textarea',
              placeholder: 'Contoh. Yogyakarta',
              value: '',
              width: '100%',
              rows: 3,
              required: true,
              rules: 'required'
            },
            {
              label: 'Column',
              type: 'column',
              sub: [
                {
                  field: 'start_date',
                  label: 'Tanggal Mulai',
                  type: 'date',
                  placeholder: 'Contoh. 2023-12-12',
                  value: '',
                  picker: false,
                  required: true,
                  rules: 'required',
                  col: 6
                },
                {
                  field: 'end_date',
                  label: 'Tanggal Selesai',
                  type: 'date',
                  placeholder: 'Contoh. 2023-12-15',
                  value: '',
                  picker: false,
                  required: true,
                  rules: 'required',
                  col: 6
                }
              ]
            },
            {
              label: 'Column',
              type: 'column',
              sub: [
                {
                  field: 'start_time',
                  label: 'Jam Mulai',
                  type: 'time',
                  placeholder: 'Contoh. 09:00',
                  value: '',
                  time: false,
                  required: true,
                  rules: 'required',
                  col: 6
                },
                {
                  field: 'end_time',
                  label: 'Jam Selesai',
                  type: 'time',
                  placeholder: 'Contoh. 14:00',
                  value: '',
                  time: false,
                  required: true,
                  rules: 'required',
                  col: 6
                }
              ]
            }
          ],

          // CONFIG PARSING ACTION
          action: {
            tab: {
              button: false,
              api: [],
              field: ''
            },
            filter: {
              button: false,
              api: ''
            },
            add: {
              button: true,
              api: 'admin/event/add',
              window: false,
              href: ''
            },
            edit: {
              button: true,
              api: 'admin/event/update',
              window: false,
              href: ''
            },
            delete: {
              button: true,
              api: 'admin/event/delete'
            },
            detail: {
              button: true,
              api: '/event/'
            },
            attachment: {
              button: false,
              api: ''
            },
            active: {
              button: false,
              api: ''
            },
            deactive: {
              button: false,
              api: ''
            },
            reject: {
              button: false,
              api: ''
            },
            approve: {
              button: false,
              api: ''
            },
            reset: {
              button: false,
              api: ''
            },
            print: {
              button: false,
              api: ''
            },
            freeze: {
              button: true,
              api: ''
            },
            hide: {
              button: true,
              api: ''
            }
          }
        }
      }
    }
  }
</script>